<template>
  <thead :class="classHeader">
  <slot name="header" />

  <tr class="text-left">
    <th
      v-if="showSelect"
      :key="-2"
      id="column-first"
      :style="headerColumnSelect.styleHeader || headerColumnSelect.style || {}"
    >
      <div class="cursor-pointer">
        <slot name="header.data-table-select">
          <v-icon v-if="iconPrimary" :color="colorShowSelect" @click="clearSelect">mdi-checkbox-marked</v-icon>
          <v-icon v-else-if="iconMinusBox" :color="colorShowSelect" @click="selectAll">mdi-minus-box</v-icon>
          <v-icon v-else @click="selectAll">mdi-checkbox-blank-outline</v-icon>
        </slot>
      </div>
    </th>

    <th :key="-1" v-if="showExpand" />

    <template v-for="(header, key) in headersExibicao">
      <th
        :key="key"
        :class="classColumnHeader(header)"
        :style="header.styleHeader || header.style || {}"
        :draggable="true"
        :title="header.title || ''"
        @click.capture="ordenarColuna(header)"
        @click="ev => $emit('click:th', ev)"
      >
        <slot
          :name="`header.${header.value}`"
          :header="header"
          :text="header.text"
          :value="header.value"
        >
          <slot :name="`header.${header.value}.text`" :header="header" :text="header.text">
            <span v-text="header.text" />
          </slot>

          <slot :name="`header.${header.value}.icon_order`">
            <template v-if="COLUNA_ORDENACAO.value === header.value">
              <v-icon v-if="COLUNA_ORDENACAO.order === 'up'" small v-text="'mdi-arrow-up'" />
              <v-icon v-else-if="COLUNA_ORDENACAO.order === 'down'" small v-text="'mdi-arrow-down'" />
            </template>
          </slot>
        </slot>
      </th>
    </template>

    <th>
      <CustomColumns
        v-if="showColumnCustom"
        :id_unico_preferencia="idUniquePreference"
        :colunas="headers"
        @update:colunas="aplicarPersonalizacaoColunas"
      />
    </th>
  </tr>

  <TLoading :loading="loading" :count-headers="headers.length + (showSelect ? 1 : 0)" />

  <slot name="header.append" />
  </thead>
</template>

<script>
import TLoading from "./TLoading";
import IndexProps from "./IndexProps";
import CustomColumns from "@/components/utils/dataTable/sysDataTable/CustomColumns.vue";

export default {
  name: "THeader",
  components: { CustomColumns, TLoading },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    headers: Array,
    qtdItens: Number,
    iconPrimary: Boolean,
    iconMinusBox: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    showExpand: IndexProps.showExpand,
    colorShowSelect: IndexProps.colorShowSelect,
    modelValue: Object,
    showSelect: IndexProps.showSelect,
    desativar_ordenacao: IndexProps.desativar_ordenacao,
    column_drag: Object,
    showColumnCustom: {
      type: [Boolean, null],
      required: false,
      default: null
    },
    idUniquePreference: {
      type: [String, null],
      required: false,
      default: null
    },
    disabledColumnsCustom: {
      type: [Array, null],
      required: false,
      default: null
    },
  },
  inject: [
    "fixedHeader",
    "itemKey"
  ],
  data: () => ({
    colunaSelecionadaDefault: { value: '', order: null },
    header_click: {},
    timer_drag_header: null
  }),
  computed: {
    COLUNA_ORDENACAO: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    },
    classHeader() {
      return {
        'header-fixed': this.fixedHeader
      }
    },
    headerColumnSelect() {
      return this.headers.find(item => item.value === "data-table-select") || {};
    },
    headersExibicao() {
      return this.headers.filter(header =>
        header !== this.headerColumnSelect &&
        header.visible !== false
      );
    },
  },
  watch: {
    qtdItens() {
      if (this.COLUNA_ORDENACAO.value) {
        this.$emit('update:ordenacao', this.COLUNA_ORDENACAO);
      } else {
        this.COLUNA_ORDENACAO = Object.assign({}, this.colunaSelecionadaDefault);
      }
    }
  },
  methods: {
    selectAll() {
      this.$emit('select-all', true);
    },
    clearSelect() {
      this.$emit('clear-select', true)
    },
    ordenarColuna(header) {
      if (this.desativar_ordenacao) {
        return;
      }

      if (header) {
        this.header_click = header;
      } else if (!header && !this.header_click) {
        return;
      }

      if (this.header_click.sortable === false) {
        this.COLUNA_ORDENACAO = {};
        return;
      }

      const ev = {
        value: this.header_click.value,
        order: null,
        header: this.header_click,
      };

      if (!this.COLUNA_ORDENACAO.order || this.COLUNA_ORDENACAO.value !== this.header_click.value) {
        ev.order = 'up';
      } else if (this.COLUNA_ORDENACAO.order === 'up') {
        ev.order = 'down';
      }

      this.COLUNA_ORDENACAO = ev;
    },
    classColumnHeader(header) {
      return {
        'cursor-pointer': header.sortable !== false && !this.desativar_ordenacao,
        'column-drag': this.column_drag.value === header.value,
      }
    },
    dragstart(ev, header) {
      ev.dataTransfer.setData("text", JSON.stringify(header));
    },
    dragover(ev, header_destino) {
      clearTimeout(this.timer_drag_header);

      const callback = () => {
        const header_origem = JSON.parse(ev.dataTransfer.getData("text"));

        if (header_destino.value === header_origem.value) {
          return;
        }

        this.$emit('update:column-drag', header_origem);

        const index_of_origem = this.headers.findIndex(item => item.value === header_origem.value);
        const index_of_destino = this.headers.indexOf(header_destino);

        this.headers.splice(index_of_origem, 1);
        this.headers.splice(index_of_destino, 0, header_origem);
      };

      this.timer_drag_header = setTimeout(callback, 5);
    },
    dragend() {
      setTimeout(() => this.$emit('update:column-drag', {}), 200);
    },
    aplicarPersonalizacaoColunas(params) {
      if (!Array.isArray(params.colunas)) return;

      const headers_value = new Map(this.headers.map(header => [header.value, header]));
      const ids_selecionados = new Set(params.colunas.map(coluna => coluna.id));

      const headers_visiveis = params.colunas.map(coluna => {
        const header = headers_value.get(coluna.id);
        if (!header) return null;

        return { ...header, visible: true };
      }).filter(Boolean);

      const headers_ocultos = this.headers
      .filter(header => !ids_selecionados.has(header.value))
      .map(header => ({ ...header, visible: false }));

      this.headers.splice(0, this.headers.length, ...headers_visiveis, ...headers_ocultos);
      this.$emit('headers:update', params.tipo);
    },
  }
}
</script>

<style scoped>
#column-first {
  width: 30px;
}

thead tr th {
  background: white;
  align-items: center;
  vertical-align: top;
  border-bottom: 1px solid #e1dfdf;
  text-align: left;
  font-size: 12px;
  color: #676767;
  padding: 5px 4px;
}

.header-fixed {
  position: sticky;
  top: 0;
}

.column-drag {
  background: #f0f6ff !important;
  border: 2px dashed #5983c3 !important;
  border-bottom: 0 !important;
  border-top-left-radius: 3px !important;
  border-top-right-radius: 3px !important;
}
</style>
